import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '../css/DailyAnalysis.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
const VisitSupport = () => {
    const navigate = useNavigate(); 
    const location = useLocation();
    const [fromDocChem, setFromDocChem] = useState(false);
    const [states, setStates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("All");
    const [selectedEmployee, setSelectedEmployee] = useState("All");
    const [retailerType, setRetailerType] = useState("All");
    const [activeStatus, setActiveStatus] = useState("All");
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayStr = yesterday.toISOString().split('T')[0];
    
    const [fromDate, setFromDate] = useState(yesterdayStr);
    const [toDate, setToDate] = useState(yesterdayStr);
    const [tableData, setTableData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [errors, setErrors] = useState({
        state: false,
        employee: false
    });
    const [prevDate, setPrevDate] = useState("");
    const [prevDateHeaders, setPrevDateHeaders] = useState([]);


    useEffect(() => {
        if (location.state) {
            // Case: Returned from doc_chem.js
            if (location.state.fromDocChem) {
                const { filters, tableState, options } = location.state;
    
                setSelectedState(filters?.selectedState || '');
                setSelectedDivision(filters?.selectedDivision || '');
                setSelectedEmployee(filters?.selectedEmployee || '');
                setFromDate(filters?.fromDate || '');
                setToDate(filters?.toDate || '');
                // setProductiveGT(filters?.productiveGT || '');
                setRetailerType(filters?.retailerType || '');
                setActiveStatus(filters?.activeStatus || '');
    
                setShowTable(tableState?.showTable || false);
                setReportData(tableState?.reportData || []);
                setTableData(tableState?.tableData || []);
    
                setStates(options?.states || []);
                setDivisions(options?.divisions || []);
                setEmployees(options?.employees || []);
            }
    
            // Clear location.state so it doesn’t persist on reload
            window.history.replaceState({}, document.title);
        } else {
            // Case: Hard refresh — reset everything
            setSelectedState('');
            setSelectedDivision('');
            setSelectedEmployee('');
            // setFromDate('');
            // setToDate('');
            // setProductiveGT('');
            // setRetailerType('');
            // setActiveStatus('');
            setShowTable(false);
            setReportData([]);
            setTableData([]);
            setStates([]);
            setDivisions([]);
            setEmployees([]);
        }
    }, [location.state]);
    
    // 👈 this will run once on mount (initial render)
    
    

    const fetchEmployees = useCallback(async (stateId, divisionName) => {
        if (!stateId) return;
        try {
        let url = `${BASE_URL}/api/employees?state_id=${stateId}`;
        if (divisionName && divisionName !== "All") {
            url += `&division=${encodeURIComponent(divisionName)}`;
        }
        const res = await axios.get(url, {
            headers: getAuthHeaders()
        });
        setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...res.data]);
        setSelectedEmployee("All");
        } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployees([]);
        }
    }, [getAuthHeaders]);

    useEffect(() => {
        const fetchStates = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/states`,{
            headers:getAuthHeaders()
            });
            setStates(response.data);
        } catch (err) {
            console.error("Error fetching states:", err);
        }
        };
        fetchStates();
    }, []);

    const handleStateChange = async (stateId) => {
        setSelectedState(stateId);
        setSelectedDivision("All");
        setSelectedEmployee("All");

        try {
        const divisionRes = await axios.get(
            `${BASE_URL}/api/divisions?state_id=${stateId}`
        );
        setDivisions(divisionRes.data);
        } catch (err) {
        console.error("Error loading divisions", err);
        }

        fetchEmployees(stateId, "All");
    };

    const handleDivisionChange = async (divisionId) => {
        setSelectedDivision(divisionId);
        setSelectedEmployee("All"); // Reset employee selection
        
        try {
            let url = `${BASE_URL}/api/employees?state_id=${selectedState}`;
            if (divisionId && divisionId !== "All") {
                const division = divisions.find(d => d.id == divisionId);
                if (division) {
                    url += `&division=${encodeURIComponent(division.name)}`;
                }
            }
            
            const res = await axios.get(url, { headers: getAuthHeaders() });
            setEmployees([{ id: "All", first_name: "All", last_name: "" }, ...res.data]);
        } catch (err) {
            console.error("Error fetching employees:", err);
            setEmployees([]);
        }
    };
    const handleGoClick = async () => {
        const newErrors = {
            state: !selectedState,
            employee: false
        };
        
        setErrors(newErrors);
        if (newErrors.state) return;
    
        setShowTable(true);
    
        try {
            const prevDateObj = new Date(toDate);
            const prevDateStr = prevDateObj.toISOString().split("T")[0];
    
            const headers = formatPrevDateHeaders(toDate);
            setPrevDateHeaders(headers);
    
            let url = `${BASE_URL}/api/visits/daily-visit-summary-exact?state_id=${selectedState}&date=${prevDateStr}`;
            
            if (selectedDivision && selectedDivision !== "All") {
                const division = divisions.find(d => d.id == selectedDivision);
                if (division) {
                    url += `&division=${encodeURIComponent(division.name)}`;
                }
            }
    
            if (selectedEmployee && selectedEmployee !== "All") {
                url += `&employee_id=${selectedEmployee}`;
            }
    
            const response = await axios.get(url, {
                headers: getAuthHeaders()
            });
            setReportData(response.data);
        } catch (error) {
            console.error("Error fetching daily summary:", error);
            setReportData([]);
        }
    };

    const getPreviousDay = (dateStr) => {
        const date = new Date(dateStr);
        date.setDate(date.getDate() - 1);
        return date.toISOString().split('T')[0];
    };
    
    const formatPrevDateHeaders = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const monthName = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        const formatted = `${day} ${monthName} ${year}`;
        setPrevDate(formatted);
    
        return [
            `${formatted} Calls`,
            `${formatted} Prod_calls`,
            `${formatted} First_call`,
            `${formatted} Last_call`,
            `${formatted} POB`
            
        ];
    };
    
    

    // Add this useEffect at the top of your component
    
      
      

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate().toString().padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

  return (
    <div className="DailyAnalysis-main-container">
      <Header />
      <Navbar />
      <div className="DailyAnalysis-filter-container">
          <h1 class="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4"><span class="text-blue-700"> Visit / </span><span class="text-blue-500">Support</span></h1>
          <div className="DailyAnalysis-row1">
                <label className="DailyAnalysis-label">State</label>
                <select className={`DailyAnalysis-dropdown ${errors.state ? 'error-border' : ''}`} 
                 onChange={(e) => {
                    handleStateChange(e.target.value);
                    setErrors({...errors, state: false});
                  }} value={selectedState} required>
                    <option value="">Select State</option>
                    {states.map((state) => (
                    <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                </select>
                <label className="DailyAnalysis-label">Division</label>
                <select className="DailyAnalysis-dropdown" onChange={(e) => handleDivisionChange(e.target.value)} value={selectedDivision}>
                    <option value="All">All</option>
                    {divisions.map((div) => (
                    <option key={div.id} value={div.id}>{div.name}</option>
                    ))}
                </select>
            </div>
            <div className="DailyAnalysis-row2">
              <label className="DailyAnalysis-label">Employee</label>
              <select className={`DailyAnalysis-dropdown ${errors.employee ? 'error-border' : ''}`}  
                     onChange={(e) => {
                    setSelectedEmployee(e.target.value);
                    setErrors({...errors, employee: false});
                    }} 
              value={selectedEmployee}>
                 <option value="All">All</option>
                 {employees.map((emp) => (
                        emp.id !== "All" && (
                            <option key={emp.id} value={emp.id}>
                                {`${emp.first_name} ${emp.last_name} (${emp.designation} | ${emp.headquarter_name} | ${emp.division} | ${emp.state_name})`}
                            </option>
                        )
                    ))}
                </select>
              <div className="DailyAnalysis-inline-field">
                    <label>Start-Date:</label>
                    <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>

                    <div className="DailyAnalysis-inline-field">
                    <label>End-Date:</label>
                    <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>  
            </div>

            {/* <div className="DailyAnalysis-row3">

            <label className="DailyAnalysis-label">Productive Greater Than </label>
            <input className="DailyAnalysis-dropdown" type="number" value={productiveGT} onChange={(e) => setProductiveGT(e.target.value)} />
            </div> */}

          
          <div className="DailyAnalysis-go-button-container">
            <button className="DailyAnalysis-gobutton" onClick={handleGoClick}>GO</button>
          </div>

        </div>
       

        {showTable && (
            <>
          <div className="DailyAnalysis-table-section">
          <div className="DailyAnalysis-title3-container">
            <h2 className="DailyAnalysis-table-title">
               {selectedEmployee !== "All" 
                ? `Employee: ${employees.find(e => e.id == selectedEmployee)?.first_name || ''} ${employees.find(e => e.id == selectedEmployee)?.last_name || ''}` 
                : "All Employees"}
            </h2>
            </div>
            <div className="DailyAnalysis-table-wrapper">
              <table className="DailyAnalysis-table">
                    <thead className="text-white">
                        <tr>
                            <th>No</th>
                            <th>Emp ID</th>
                            <th>Employee</th>
                            <th>State</th>
                            <th>HQ</th>
                            <th>Desi</th>
                            <th>Division</th>
                            <th>DOJ</th>
                            <th>Immediate Manager</th>
                            <th>Leave</th>
                            {prevDateHeaders.map((head, idx) => (
                                <th key={idx}>{head}</th>
                            ))}
                            <th>Working <br/>Hours In <br/>Field</th>
                            <th>POB Total</th>
                            <th>No of <br/>Customer</th>
                            <th>Total <br/>Customer<br/> Visits</th>
                            <th>Call Avg</th>
                            <th>JW</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportData.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.emp_id}</td>
                                <td>{row.employee}</td>
                                <td>{row.state}</td>
                                <td>{row.hq}</td>
                                <td>{row.designation}</td>
                                <td>{row.division}</td>
                                <td>{formatDate(row.doj)}</td>
                                <td>{row.manager}</td>
                                <td>{row.leave_type}</td>
                                <td>{row.calls}</td>
                                <td>{row.prod_calls}</td>
                                <td>{row.first_call}</td>
                                <td>{row.last_call}</td>
                                <td>{row.pob}</td>
                                <td>{row.working_hours}</td>
                                <td>{row.pob_total}</td>
                                <td>{row.no_of_customers}</td>
                                <td>{row.total_customer_visits}</td>
                                <td>{row.call_avg}</td>
                                <td>{row.jw}</td>
                            </tr>
                        ))}
                    </tbody>


              </table>
            </div>
          </div>
        

        <div className="DailyAnalysis-button-container">
          <button className="DailyAnalysis-printbutton">Print</button>
          <button className="DailyAnalysis-exportbutton">Export to Excel</button>
        </div>
        </>
      )}
      <Footer />
    </div>
  );
};

export default VisitSupport;
